import styled from "styled-components";
import { Tabs } from "antd";

export const SelectTabsContainer = styled.div`
  .ant-tabs {
    margin: 45px 0;    
    overflow: initial; // added to show select dropdown in investment rae forms
    .ant-tabs-bar {
      display: flex;
      align-items: center;
      border-bottom: none;
      margin: 0;
      .ant-tabs-extra-content {
        font-size: ${props => props.theme.fontSize.primary};
        font-family: ${props => props.theme.fontFamily.helveticaNeue};
        color: ${props => props.theme.fontColors.textColor};        
        letter-spacing: normal;
        line-height: normal;
      }
      .ant-tabs-nav-container {        
        height: auto !important;
        margin-left: 1.25rem;
        .ant-tabs-tab-arrow-show{
          display: none;
        }
        .ant-tabs-nav {
          & > div {
            display: flex;
          
            align-items: center;
            .ant-tabs-tab:first-child {
              margin-left: 1px;
            }
            .ant-tabs-tab {
              display:flex;
              align-items:center;
              font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
              font-size: ${props => props.theme.fontSize.secondary};
              color: ${props => props.theme.fontColors.textColor};  
              background-color: #ffffff;
              margin-right: 0;
              padding: 11px 20px;              
              border-radius: 0;
              border: 1px solid
                ${props => props.theme.border.filledTabsInactive};
              line-height: ${props => props.theme.lineHeight.normal};
              letter-spacing: ${props => props.theme.letterSpacing.normal};
              transition: none;
              text-align: center;
              height:38px!important;
              :hover{
                color: #505050;
              }
              &.ant-tabs-tab-active {
                color: white;
                border: none;
                background-color: ${props =>
                  props.theme.backgroundColor.primaryColor};
               height:49px!important;
              }
            }
          }
        }
      }
    }
  }

  @media only screen and (max-width: 991.92px) {
    .ant-tabs {
      margin: 40px 0 36px;
      .ant-tabs-bar {
        flex-direction: column;
        margin: 0;
        .ant-tabs-extra-content {
          align-self: flex-start;
          line-height: 1.43;
          margin-bottom: 10px;
          font-size: ${props => props.theme.fontSize.secondary};
        }
        .ant-tabs-nav-container {
          font-size: ${props => props.theme.fontSize.tertiary};
          width: 100%;
          margin-left: 0;
          padding: 0;
          height: auto !important;
          .ant-tabs-nav {
            width: 100%;
            & > div {
              width: 100%;
              .ant-tabs-tab {
                white-space: initial;                
                height: auto;                
                font-size: ${props => props.theme.fontSize.tertiary};
                max-width: 33.33%;
                padding: 5px 12px;
                letter-spacing: ${props => props.theme.letterSpacing.normal};
                text-align: left;
                &:not(:last-child) {
                }
                &.ant-tabs-tab-active {
                  font-size: ${props => props.theme.fontSize.secondary};                  
                }
              }
            }
          }
        }
      }
    }
  }

  @media only screen and (max-width: 991.92px) {
    .ant-tabs {
      .ant-tabs-bar {
        flex-direction: column;
        .ant-tabs-nav-container {
          .ant-tabs-nav {
            & > div {
              .ant-tabs -tab {
                &:not(:last-child) {
                }
                &.ant-tabs-tab-active {
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const TabPane = styled(Tabs.TabPane)``;
